/**
 * Unified loading component
 *
 * @param {string} size - "sm" | "md" | "lg" (default: "md")
 * @param {string} message - Optional loading message
 * @param {boolean} fullScreen - Center in full viewport height
 * @param {string} className - Additional classes
 *
 * @example
 * <Loading />
 * <Loading size="lg" message="Loading name..." fullScreen />
 * <Loading size="sm" />
 */
const Loading = ({ size = "md", message, fullScreen = false, className = "" }) => {
  const sizeClasses = {
    sm: "loading-sm",
    md: "loading-md",
    lg: "loading-lg",
  };

  const containerClasses = fullScreen
    ? "flex flex-col justify-center items-center min-h-screen"
    : "flex flex-col justify-center items-center py-8";

  return (
    <div className={`${containerClasses} ${className}`}>
      <span className={`loading loading-ring ${sizeClasses[size]}`}></span>
      {message && (
        <span className="text-sm text-base-content/50 mt-3">{message}</span>
      )}
    </div>
  );
};

export default Loading;
